import * as React from 'react';
import * as State from './service/AppState';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Help } from './components/Help';
import { OtcRepoComponent } from './components/OtcRepoApp';
import { Login } from './components/auth/Login';
import { Logout } from './components/auth/Logout';
import { PersonProfile } from './components/PersonProfile';
import { Register } from './components/Register';
import { GlobalSettings } from './components/GlobalSettings';
import { ChangePassword } from './components/auth/ChangePassword';
import { NotFound404 } from './components/NotFound404';
import { Switch } from 'react-router-dom';


//<Route path='/settings' component={Settings}/>
//<Route component={NotFound404} />
export const routes = <Layout history={history} location={location}>
    <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/help' component={Help} />
        <Route exact path='/app' component={OtcRepoComponent} />
        <Route exact path='/login' component={Login} />
        <Route exact path='/chpassword' component={ChangePassword} />
        <Route exact path='/logout' component={Logout} />
        <Route exact path='/register' component={Register} />
        <Route exact path='/profile' component={PersonProfile} />
        <Route path="*" component={NotFound404} />
    </Switch>
</Layout>;
